import { SUPPORT_TICKET_STATUS } from '../../constants/supportTicket'

export default function SupportTicketStatus({ status }) {
  const selectedStatus = Object.values(SUPPORT_TICKET_STATUS).find(
    (statusItem) => statusItem.key.toLowerCase() === status.toLowerCase()
  )
  const statusContent = selectedStatus || {}

  if (!statusContent.label) return

  return (
    <span className={statusContent.className + ' px-2 py-1 rounded-lg text-xs font-medium'}>
      {statusContent.label}
    </span>
  )
}
